<template>
  <page>
    <module title="提现管理" enable-flex>
      <m-search ref="search" @search="searchHandle">
        <m-search-item label="提现单号">
          <c-input name="apply_number"></c-input>
        </m-search-item>
        <m-search-item label="提现账号">
          <c-input name="bank_card"></c-input>
        </m-search-item>
		<m-search-item label="到账渠道">
		  <c-select name="withdraw_channel" :options="WithdrawChannel"></c-select>
		</m-search-item>
		<m-search-item label="状态" colspan="2">
		  <c-checkbox-group name="state" :options="State"></c-checkbox-group>
		</m-search-item>
		<m-search-item label="交易时间" colspan="2">
		  <c-datetime start-name="begin_time" end-name="end_time" range></c-datetime>
		</m-search-item>
      </m-search>

	  <m-operate>
          <c-button v-if="auth('b_extract_apply')" @click="applyExtract">申请提现</c-button>
          <c-button color="m" hollow @click="syncExport()">导出</c-button>
	  </m-operate>

      <c-table ref="table" height="grow">
		<c-table-column
		  	label="提现单号"
		  	name="apply_number"
		  	width="130"
		></c-table-column>
        <c-table-column
        	label="状态"
        	name="state"
        	width="80"
        >
        	<template v-slot="{data}">
        		<span style="color:coral" v-if="data.state==1">{{StateName[data.state]}}</span>
        		<span style="color:dodgerblue" v-if="data.state==2">{{StateName[data.state]}}</span>
        		<span style="color:dodgerblue" v-if="data.state==3">{{StateName[data.state]}}</span>
        		<span style="color:green" v-if="data.state==4">{{StateName[data.state]}}</span>
        		<span style="color:red" v-if="data.state==5">{{StateName[data.state]}}</span>
        		<span style="color:gray" v-if="data.state==10">{{StateName[data.state]}}</span>
        	</template>
        </c-table-column>
        
        <c-table-column
        	label="提现金额"
        	name="extract_money"
        	width="90"
        >
          <template v-slot="{data}">
        	<span style="color:dodgerblue" v-if="data.extract_money && data.extract_money>0">￥{{data.extract_money.toFixed(2)}}</span>
        	<span v-else>--</span>
          </template>
        </c-table-column>
        
        <c-table-column
        	label="提现手续费"
        	name="withdraw_fee"
        	width="90"
        >
        	<template v-slot="{data}">
        		<span style="color:dodgerblue" v-if="data.withdraw_fee && data.withdraw_fee>0">￥{{data.withdraw_fee.toFixed(2)}}</span>
        		<span v-else>无</span>
        	</template>
        </c-table-column>
        		
        <c-table-column
        	label="申请时间"
        	name="apply_date"
        	width="140"
        ></c-table-column>
        		
		<c-table-column
			label="提现渠道"
			name="withdraw_channel"
			width="140"
		>
			<template v-slot="{data}">
				{{WithdrawChannelName[data.withdraw_channel]}}
			</template>
		</c-table-column>	
				
        <c-table-column
        	label="提现账号"
        	name="withdraw_account_number"
        	width="380"
        >
			<template v-slot="{data}">
				<span v-if="data.withdraw_channel == 1">{{data.bank_name}}（{{data.account_name}} {{data.bank_card}}）</span>
				<span v-else>{{data.withdraw_account_number}}</span>
			</template>
        </c-table-column>
        
        <!-- <c-table-column
        	label="备注"
        	name="remark"
        	width="300"
        ></c-table-column> -->
        		
        <c-table-column
        	label="申请人姓名"
        	name="apply_user_realname"
        	width="90"
        ></c-table-column>
        		
        <c-table-column
        	label="申请时间"
        	name="apply_date"
        	width="140"
        ></c-table-column>
        
        <c-table-column
            type="button"
            label="操作"
            width="90"
        >
          <template #default="{data}">
            <c-table-button @click="detail(data)">详情</c-table-button>
          </template>
        </c-table-column>
      </c-table>
    </module>
	
	<c-dialog ref="applyDialog" title="申请提现" width="500" height="380" @resolve="submitApply">
		<c-form ref="applyForm" unit-width="100%">
			<c-form-item label="提现金额" :tip="extractTip" required>
			  <c-input name="extract_money" v-model="extract_money" type="number" unit="元" decimal="2" :range="[1,this.can_withdraw_balance]" @blur="calCharge()"></c-input>
			</c-form-item>
			<c-form-item label="提现渠道" tip="提现到账的账户类型" required>
			  <c-radio-group  name="withdraw_channel" v-model="withdraw_channel" :options="WithdrawChannel"></c-radio-group>
			</c-form-item>
			<c-form-item label="提现账号" v-show="withdraw_channel != 1 && withdraw_channel != 4" tip="提现至哪个账号" required>
			  <c-input name="withdraw_account_number"></c-input>
			</c-form-item>
			<c-form-item label="开户银行" v-show="withdraw_channel == 1" required>
			  <c-input name="bank_name"></c-input>
			</c-form-item>
			<c-form-item label="银行账号" v-show="withdraw_channel == 1" required>
			  <c-input name="bank_card" type="number"></c-input>
			</c-form-item>
			<c-form-item label="持卡人姓名" v-show="withdraw_channel == 1" required>
			  <c-input name="account_name"></c-input>
			</c-form-item>
		</c-form>
	</c-dialog>

    <c-dialog ref="detailDialog" title="提现详情" width="800" :button="false">
		<c-detail column="2">
			<c-detail-item label="提现单号" >
				{{detailData.apply_number}}
			</c-detail-item>
			<c-detail-item label="状态" >
				{{StateName[detailData.state]}}
			</c-detail-item>
			<c-detail-item label="提现金额" >
				￥{{detailData.extract_money}}
			</c-detail-item>
			<c-detail-item label="提现手续费" >
				￥{{detailData.withdraw_fee}}
			</c-detail-item>
			<c-detail-item label="提现渠道"  colspan="2">
				<c-image v-if="detailData.withdraw_img_url" :src="detailData.withdraw_img_url" size="120" preview></c-image>
				{{WithdrawChannelName[detailData.withdraw_channel]}}
			</c-detail-item>
			<c-detail-item label="提现账号" colspan="2">
				<span v-if="detailData.withdraw_channel == 1">{{detailData.bank_name}}（{{detailData.account_name}} {{detailData.bank_card}}）</span>
				<span v-if="detailData.withdraw_channel == 4">平台账户</span>
				<span v-else>{{detailData.withdraw_account_number}}</span>
			</c-detail-item>
			<c-detail-item label="备注"   colspan="2">
				{{detailData.remark}}
			</c-detail-item>
			<c-detail-item label="申请人" >
				{{detailData.apply_user_realname}}
			</c-detail-item>
			<c-detail-item label="申请时间">
				{{detailData.apply_date}}
			</c-detail-item>
			<c-detail-item v-if="detailData.state == 2 || detailData.state == 3 || detailData.state == 4 || detailData.state == 5 || detailData.state == 10" label="审批时间">
				{{detailData.audit_date}}
			</c-detail-item>
			<c-detail-item v-if="detailData.state == 10" label="驳回原因"   colspan="2">
				{{detailData.reject_reason}}
			</c-detail-item>
			<c-detail-item v-if="detailData.state == 4" label="打款时间">
				{{detailData.playmoney_date}}
			</c-detail-item>
			<c-detail-item v-if="detailData.state == 4" label="打款凭证">
				<c-file :src="detailData.playmoney_voucher_url" v-if="detailData.withdraw_channel != 4" media></c-file>
				<span v-else>到账情况请前往平台查看</span>
			</c-detail-item>
		</c-detail>
    </c-dialog>
  </page>
</template>

<script>
	import {mapState} from 'vuex'
export default {
	props: {
		state: String
	},
	
	computed: {
		...mapState(['systemConfig','userInfo']),
	},
	
	// 监听器
	watch: {
		// 监听data中a的变化，val为变化后的值，old为变化前的值
		withdraw_channel(val, old) {
			this.calCharge();
		},
	},
	
  data() {
    return {
        workType:10,
        searchParams:{},
		State: [{
				name: '待审批',
				value: 1
			},{
				name: '待打款',
				value: 2
			// },{
			// 	name: '待到账',
			// 	value: 3
			},{
				name: '打款到帐',
				value: 4
			// },{
			// 	name: '打款失败',
			// 	value: 5
			},{
				name: '审批驳回',
				value: 10
			}
		],
		StateName :{
			1:'待审批',
			2:'待打款',
			3:'待到账',
			4:'打款到帐',
			5:'打款失败',
			10:'审批驳回'
		},
		WithdrawChannel: [{
				name: '银行卡',
				value: 1
			},{
				name: '支付宝',
				value: 2
			},{
				name: '微信',
				value: 3
			},
		],
		WithdrawChannelName: {
			1:'银行卡',
			2:'支付宝',
			3:'微信',
			4:'平台账户'
		},
		detailData : {},
		withdraw_channel : 1,
		extract_money : 0,
		extractTip : '',
		can_withdraw_balance: 0
    }
  },
  
  mounted() {
        this.$refs.search.set({
              state: this.state
        });

        this.$refs.search.search();

        //如果是分销账户，则有提现至月账户的类型
        if(this.systemConfig.account_balance_enabled  == 'ON' && this.userInfo.platform_user_id!=0 && this.userInfo.stationed_type == 2){
            this.WithdrawChannel.push({
                name: '平台账户',
                value: 4
            });
        };

        this.extractTip = '单笔提现最高'+this.systemConfig.station_a_single_withdrawal_limit +'元';
  },

  methods: {
    searchHandle(data) {
      this.$refs.table.load({
        url: '/stationed/extract/list',
        data
      });
      this.searchParams = data;
    },
	//提现申请详情
    detail(data) {
      this.request({
      	url: '/stationed/extract/detail',
      	data: {id: data.id},
      	loading: true,
      	success: data => {
      		this.detailData = data;
      	}
      });
	  
      this.$refs.detailDialog.open();
    },
	//申请提现弹框
    applyExtract() {
      this.$refs.applyForm.clear();
      this.$refs.applyForm.set({withdraw_channel:1});
	  
	  this.request({
	    url: '/stationed/account/info',
	    data: {},
	    success: data => {
	      this.can_withdraw_balance = data.can_withdraw_balance;
		  this.$refs.applyDialog.open();
	    }
	  });
    },
	//计算服务费
	calCharge(){
      if(this.extract_money) {
		this.request({
		  url: '/stationed/extract/charge',
		  data: {extract_money: this.extract_money},
		  success: data => {
			if(this.withdraw_channel != 4){
				this.extractTip = '单笔提现最高' + data.withdrawal_limit + '元,费率('+data.withdrawal_rate+'),服务费'+data.withdraw_fee+ '元';
			}else{
				this.extractTip = '无额度限制，无服务费，到账快';
			}
		  }
		});
      }else{
		if(this.withdraw_channel != 4){
			this.extractTip = '单笔提现最高'+this.systemConfig.station_a_single_withdrawal_limit +'元';
		}else{
			this.extractTip = '无额度限制，无服务费，到账快';
		}
      }
	},
    //提交提现申请
    submitApply(stop) {
      stop();
      this.$refs.applyForm.submit({
        url:'/stationed/extract/apply',
        rule: {
          extract_money: '请填写提现金额',
          withdraw_channel: '请选择提现渠道',
		  bank_name: [{
			type: 'empty',
		    message: '请填写开户银行',
		    skip: (value,data) => {
				return data.withdraw_channel != 1;
		    }
		  }],
		  bank_card: [{
		  	type: 'empty',
		    message: '请填写银行账号',
		    skip: (value,data) => {
		  		return data.withdraw_channel != 1;
		    }
		  }],
		  account_name: [{
		  	type: 'empty',
		    message: '请填写持卡人姓名',
		    skip: (value,data) => {
		  		return data.withdraw_channel != 1;
		    }
		  }],
		  withdraw_account_number: [{
		  	type: 'empty',
		    message: '请输入提现账号',
		    skip: (value,data) => {
		  		return data.withdraw_channel != 2 && data.withdraw_channel != 3;
		    }
		  }]
        },
        dataFormatter: data => {
          return data;
        },
        success: (data, res) => {
          this.$message({
            message: '申请成功',
            type: 'success'
          });
          this.$refs.table.update();
          this.$refs.applyDialog.close();
        }
      });
    },
    /**同步导出数据**/
    syncExport(){
          this.request({
              url: '/export/url',
              data: Object.assign({
                  work_type: this.workType //业务类型
              },this.searchParams),
              success: data => {
                  this.download({
                      fileName: data.filename,
                      url: data.url,
                      loading: {
                          message: '数据文件生成中...'
                      }
                  })
              }
          });
      }
  }
}
</script>

<style lang="stylus" scoped>
</style>
